import React, { useEffect } from 'react';
import { Grid, Paper } from '@mui/material';
import CarePathService from '../../../API/CarePathService.js';
import { FormProvider } from '../../../context/Form.provider';
import LoggerProvider from '../../../context/Logger/Logger.provider';
import styles from '../../../styles/PageStyles.js';
import theme from '../../../styles/PageTheme';
import { keyName } from '../constants/index.js';
import * as Utils from './Mapper.js';
import EpeRouter from './EpeRouter.js';

const classes = styles(theme);

export default function Home(props) {
    useEffect(() => {
        Utils.doMapping();
    }, []);
    return (
        <FormProvider>
            <LoggerProvider>
                <div data-testid="{props.name}">
                    <Grid container justifyContent="center">
                        <Grid item xs={12}>
                            <Paper elevation={2} sx={classes.paper}>
                                <EpeRouter data-testid="router" {...props} />
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </LoggerProvider>
        </FormProvider>
    );
}
